import React from "react";
import MainLaundryTable from "components/Tables/MainLaundry/MainLaundryTable";
import PlanTable from "components/Tables/plan/PlanTable";

const ListPlan = () => {
  return (
    <div>
      <PlanTable />
    </div>
  );
};

export default ListPlan;
